import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { CopyInput } from "@/components/copy-input";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	FormCard,
	FormCardContent,
	FormCardHeader,
	FormCardTitle,
} from "@/components/ui/form-card";
import { Label } from "@/components/ui/label";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { getCdnUrl } from "@/lib/url";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/channels/$channelId/directories")({
	component: Page,
	params: z.object({
		channelId: z.coerce.number(),
	}),
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			orpc.channels.show.queryOptions({
				input: {
					channelId: params.channelId,
				},
			}),
		);
	},
});

function Page() {
	const params = Route.useParams();

	const { data: channelDirectories } = useSuspenseQuery(
		orpc.channels.listDirectories.queryOptions({
			input: {
				channelId: params.channelId,
			},
		}),
	);

	return (
		<div className="px-4 lg:px-6 grid grid-cols-12 gap-6">
			<FormCard className="col-span-12">
				<FormCardHeader>
					<FormCardTitle>Directories</FormCardTitle>
				</FormCardHeader>
				<FormCardContent className="p-0">
					<Table>
						<TableBody>
							{channelDirectories?.map((channelDirectory) => (
								<TableRow key={channelDirectory.ID}>
									<TableCell>
										<div className="flex gap-4 items-center">
											<Avatar className="size-12" rounded="sm">
												<AvatarImage
													alt={channelDirectory.Directories.DirectoryName}
													src={getCdnUrl(channelDirectory.Directories.IconURL)}
													className="object-contain"
												/>
												<AvatarFallback className="uppercase">
													{channelDirectory.Directories.DirectoryName.slice(
														0,
														1,
													)}
												</AvatarFallback>
											</Avatar>
											<div className="grid flex-1 text-left text-sm leading-tight">
												<div className="flex items-center">
													<Label>
														{channelDirectory.Directories.DirectoryName}
													</Label>
												</div>
											</div>
										</div>
									</TableCell>
									<TableCell>
										<CopyInput
											defaultValue={getCdnUrl(channelDirectory.DirectoryRSS)}
											className="w-full"
											placeholder="https://example.com/rss"
										/>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</FormCardContent>
			</FormCard>
		</div>
	);
}
